import { AxiosPromise } from "axios";
import { request } from "./request";
import { EwaiverCreatePayload, EwaiverUpdatePayload } from ".";
import { buildEwaiverCreateFormData } from "../hooks/useCreateEwaiver";
import { buildEwaiverEditFormData } from "../hooks/useEditEwaiver";

export const ewaiverApi = {
  findAll: (page: number, params?: any): AxiosPromise<any> =>
    request({
      url: `/e-waiver/page/${page}`,
      method: "get",
      params,
    }),

  detail: (id: string): AxiosPromise<any> =>
    request({
      url: `/e-waiver/${id}`,
      method: "get",
    }),

  create: (data: EwaiverCreatePayload): AxiosPromise<any> =>
    request({
      url: "/e-waiver/",
      method: "post",
      data: buildEwaiverCreateFormData(data),
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),

  update: (id: string, data: EwaiverUpdatePayload): AxiosPromise<any> =>
    request({
      url: `/e-waiver/${id}`,
      method: "put",
      data: buildEwaiverEditFormData(data),
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),

  delete: (id: number): AxiosPromise<any> =>
    request({
      url: `/pickup/events/${id}`,
      method: "delete",
    }),

  updateStatus: (id: string, status: boolean): AxiosPromise<any> =>
    request({
      url: `/e-waiver/${id}/status/${status}`,
      method: "put",
    }),

  getTracking: (id: string, params?: any): AxiosPromise<any> =>
    request({
      url: `/e-waiver/${id}/tracker`,
      method: "get",
      params,
    }),
};
